import { CreateLineItemBase } from './base';
import { LineItemTargetType, PriceListItemType } from 'src/types';
import { computed } from 'mobx';

export class ContractorLineItem extends CreateLineItemBase {
  readonly invoiceTo = LineItemTargetType.Contractor;
  readonly priceListItemType = PriceListItemType.Contractor;

  @computed get serialized() {
    return {
      priceListItemId: this.key,
      lineItemType: this.lineItemType,
      priceListItemType: this.priceListItemType,
      qty: this.qty,
      lineItemInvoicedId: this.lineItemInvoicedId,
      comment: this.comment,
      sellerId: this.sellerId,
    };
  }
}
